<template>
    <div>
        <header class="header-wrapper">
            <div class="header-box">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <header-nav></header-nav>
                        </div>
                    </div>
                </div>
            </div>
            <section class="header-banner banner-additional-service-1">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-md-12 col-lg-5">
                            <div class="img-wrapper">
                                <img src="~img/banner-additional-service-1.jpg" :alt="$t('meta.prohibited_items.h1')"  :title="$t('meta.prohibited_items.h1')">
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-7">
                            <div class="header-banner-content-wrapper">
                                <h1 class="h1-title">{{$t('meta.prohibited_items.h1')}}</h1>
                                <p class="header-banner-description">Lorem ipsum - tai fiktyvus tekstas naudojamas spaudos ir grafinio
                                    dizaino pasaulyje jau nuo XVI a. pradžios. Lorem Ipsum tapo standartiniu fiktyviu tekstu, kai nežinomas
                                    spaustuvininkas atsitiktine tvarka išdėliojo raides atspaudų prese ir tokiu būdu sukūrė raidžių
                                    egzempliorių. Šis tekstas išliko beveik nepasikeitęs ne tik penkis amžius, bet ir įžengė i kopiuterinio
                                    grafinio dizaino laikus. i</p>
                                <div class="button-wrapper">
                                    <button type="button" class="btn btn-accent">Active</button>
                                    <button type="button" class="btn btn-accent hover">Hover</button>
                                    <button type="button" class="btn btn-accent active">Pressed</button>
                                </div>
                                <div class="text-small">Lorem ipsum - tai fiktyvus tekstas naudojamas.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </header>

        <main class="main-box">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <div class="card-columns">
                            <p>Jau seniai žinoma, kad vertinant dizainą ir kompoziciją, blaško skaitomas tekstas. Tad Lorem Ipsum
                                naudojamas tam, kad daugiau ar mažiau normalizuotų raidžių paskirstymą vietoje paprasto dubliavimo: „Tekstas
                                tekstas tekstas tekstas...“. Daugelis leidybinių sistemų programų, o taip pat ir Hiperteksto kalbos
                                redaktoriai naudoja Lorem Ipsum kaip demonstracinę numatyto teksto versiją, todel žodžių „Lorem Ipsum“
                                internetinė paieška parodo daug tinklalapių kurie yra dar besikuriantys. Egzistuoja ne mažai įvairių Lorem
                                Ipsum versijų. Kai kurios iš jų buvo sukurtos per klaidą, kitos - tyčia (pvz. jumoristinės).</p>
                            <p>Daug kas galvoja, kad Lorem Ipsum - tai vien tik atsitiktinai surinktas tekstas, bet taip nėra. Jo šaknis
                                galima rasti klasikiniame Lotynų kalba parašytame kūrinyje, išleistame 45 pr. m. e., t.y. prieš du
                                tūkstančius metų. Richard McClintock, lotynų kalbos profesorius Hampden-Sydney (JAV) koledže, išrinko vieną
                                iš neaiškesnių žodžių iš Lorem Ipsum ištraukos - „consectetur“, ir ėmėsi ieškoti jo klasikinėje lotynų
                                kalbos literatūroje.</p>
                        </div>
                        <article>
                            <h2 class="h2-title">H2 Kur jį gauti?</h2>
                            <p>Jau seniai žinoma, kad vertinant dizainą ir kompoziciją, blaško skaitomas tekstas. Tad Lorem Ipsum
                                naudojamas tam, kad daugiau ar mažiau normalizuotų raidžių paskirstymą vietoje paprasto dubliavimo: „Tekstas
                                tekstas tekstas tekstas...“. Daugelis leidybinių sistemų programų, o taip pat ir Hiperteksto kalbos
                                redaktoriai naudoja Lorem Ipsum</p>
                            <p><b>Egzistuoja ne mažai įvairių Lorem Ipsum versijų. Kai kurios iš jų buvo sukurtos per klaidą, kitos -
                                tyčia.</b></p>
                        </article>

                        <div class="boxiti-bullets mt-5 border-top">
                            <div class="boxiti-bullets-content">
                                <h3 class="h3-title">H3 boxiti bullets</h3>
                                <ul class="list-circle mt-4">
                                    <li>Phasellus a nunc nec ipsum tincidunt blandit quis sodales metus.</li>
                                    <li>Mauris vitae elit tempor, varius ante eu, rutrum mi.</li>
                                    <li>Nullam dignissim libero a nibh eleifend, in rhoncus erat elementum.</li>
                                    <li>Nullam efficitur nibh vel lacus placerat vulputate.</li>
                                    <li>Nullam dignissim libero a nibh eleifend, in rhoncus erat elementum.</li>
                                    <li>Nullam efficitur nibh vel lacus placerat vulputate.</li>
                                </ul>
                            </div>
                            <div class="block-border-blue">Klasikinį Lorem Ipsum teksto pavyzdį, naudojamą nuo XVI a., galima pamatyti
                            svetainės apačioje.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main><!-- End Main -->
        <div class="full">
            <div class="full-background"></div>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <div class="row">
                            <div class="col-md-5">
                                <div class="full-info">
                                    <div>
                                        <h4 class="full-info-title">H2 Kur jį gauti?</h4>
                                        <span class="full-info-text">Jau seniai žinoma, kad vertinant dizainą ir kompoziciją, blaško skaitomas tekstas. Tad Lorem Ipsum naudojamas tam, kad daugiau ar mažiau normalizuotų raidžių paskirstymą vietoje paprasto dubliavimo: „Tekstas tekstas tekstas tekstas...“. </span>
                                    </div>
                                    <a href="#" class="full-info-link">sužinoti daugiau</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="full-img">
                <img src="~img/full-img.png" :alt="$t('meta.prohibited_items.h1')"  :title="$t('meta.prohibited_items.h1')">
            </div>
        </div>
        <div class="table-section bg-white">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <h5 class="h5-title">H5 Kur jį gauti?</h5>
                        <div class="table-container">
                            <div class="table-container-header">
                                <div class="table-column table-column-1">Lorem</div>
                                <div class="table-column table-column-2">Dolor amet</div>
                                <div class="table-column table-column-3">Ut aut reiciendi</div>
                                <div class="table-column table-column-4">At vero eos</div>
                                <div class="table-column table-column-5">Dolor sit</div>
                            </div>
                            <div class="table-container-body">
                                <div class="table-row">
                                    <div class="table-column table-column-1">1</div>
                                    <div class="table-column table-column-2">Lorem ipsum</div>
                                    <div class="table-column table-column-3">Lorem ipsum</div>
                                    <div class="table-column table-column-4"><i class="icon-ok"></i></div>
                                    <div class="table-column table-column-5">Rinktis</div>
                                </div>
                                <div class="table-row">
                                    <div class="table-column table-column-1">2</div>
                                    <div class="table-column table-column-2">Lorem ipsum</div>
                                    <div class="table-column table-column-3">dolor sit amet,</div>
                                    <div class="table-column table-column-4"> -</div>
                                    <div class="table-column table-column-5 text-blue">Rinktis</div>
                                </div>
                                <div class="table-row">
                                    <div class="table-column table-column-1">3</div>
                                    <div class="table-column table-column-2">Lorem ipsum</div>
                                    <div class="table-column table-column-3">consectetur</div>
                                    <div class="table-column table-column-4"><i class="icon-ok"></i></div>
                                    <div class="table-column table-column-5">Rinktis</div>
                                </div>
                                <div class="table-row">
                                    <div class="table-column table-column-1">4</div>
                                    <div class="table-column table-column-2">Lorem ipsum</div>
                                    <div class="table-column table-column-3">dipiscing elit,</div>
                                    <div class="table-column table-column-4"><i class="icon-ok"></i></div>
                                    <div class="table-column table-column-5 text-blue">Rinktis</div>
                                </div>
                                <div class="table-row">
                                    <div class="table-column table-column-1">5</div>
                                    <div class="table-column table-column-2">Lorem ipsum</div>
                                    <div class="table-column table-column-3">sed do</div>
                                    <div class="table-column table-column-4"><i class="icon-ok"></i></div>
                                    <div class="table-column table-column-5">Rinktis</div>
                                </div>
                                <div class="table-row">
                                    <div class="table-column table-column-1">6</div>
                                    <div class="table-column table-column-2">Lorem ipsum</div>
                                    <div class="table-column table-column-3">eiusmod</div>
                                    <div class="table-column table-column-4"> -</div>
                                    <div class="table-column table-column-5">Rinktis</div>
                                </div>
                                <div class="table-row">
                                    <div class="table-column table-column-1">7</div>
                                    <div class="table-column table-column-2">Lorem ipsum</div>
                                    <div class="table-column table-column-3">dolor sit amet,</div>
                                    <div class="table-column table-column-4"> -</div>
                                    <div class="table-column table-column-5">Rinktis</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="comments">
            <div class="container">
                <div class="carousel">
                    <div class="row">
                        <div class="col-lg-4">
                            <div class="comments-item">
                                <div class="comments-item-img">
                                    <img src="~img/comment1.png" :alt="$t('meta.prohibited_items.h1')"  :title="$t('meta.prohibited_items.h1')">
                                </div>
                                <h3 class="comments-item-title">mariukas, finita įkūrėjas</h3>
                                <span class="comments-item-text">Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Curabitur a sem sollicitudin!</span>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="comments-item">
                                <div class="comments-item-img">
                                    <img src="~img/comment2.png" :alt="$t('meta.prohibited_items.h1')"  :title="$t('meta.prohibited_items.h1')">
                                </div>
                                <h3 class="comments-item-title">algiukas, jurgurtita įkūrėjas</h3>
                                <span class="comments-item-text">Phasellus viverra turpis est. Quisque egestas lorem eros, condimentum aliquet.</span>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="comments-item">
                                <div class="comments-item-img">
                                    <img src="~img/comment3.png" :alt="$t('meta.prohibited_items.h1')"  :title="$t('meta.prohibited_items.h1')">
                                </div>
                                <h3 class="comments-item-title">agnutė, laidita įkūrėja</h3>
                                <span class="comments-item-text">Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Curabitur a sem sollicitudin!</span>
                            </div>
                        </div>
                    </div>
                    <ol class="carousel-indicators">
                        <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="1"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="2"></li>
                        <li data-target="#carouselExampleIndicators" data-slide-to="3"></li>
                    </ol>
                </div>
            </div>
        </div>

        <try-it-section></try-it-section>

        <footer-component></footer-component>
    </div>
</template>

<script>
    import TryItSection from '~cp/Public/PublicComponets/TryItSection.vue'
    export default {
        name: 'FriendlyThingsPage',
        components: {
            TryItSection
        },
        beforeRouteEnter(from, to, next) {
            next((vm) => vm.$store.dispatch('changeStylesSpecialPage', 'additional-service'))
        },
        beforeRouteLeave(from, to, next) {
            this.$store.dispatch('changeStylesSpecialPage', '').then(() => next())
        },
        metaInfo() {
            return {
                title: this.$t('meta.prohibited_items.title'),
                meta: [
                    { vmid: 'description', name: 'description', content: this.$t('meta.prohibited_items.description') },
                ]
            }
        },
    }

</script>



// WEBPACK FOOTER //
// src/components/Public/FriendlyThingsPage.vue